module.exports = __webpack_public_path__ + "fonts/VetoSans-Light_3.2e9f29d5.woff2";